import type { CustomIconName } from "@/components/icons/CustomIcons";
import { getLastFlowWorkspacePath } from "@/lib/utils/calendar-navigation";

export interface MainNavItem {
  path: string;
  icon: CustomIconName;
  label: string;
}

// "/catalog" is core (always available: basic product/service registration).
// "/products-services" used to be a separate stock-flavored view of the same
// section; the route now just redirects to "/catalog", so the icon points
// there directly instead of a path that only stock-active customers could see
// in navigation-config (otherwise the icon vanished entirely for everyone else).
export const MAIN_NAV_ITEMS: MainNavItem[] = [
  { path: "/patients", icon: "paws", label: "patients" },
  { path: "/calendar", icon: "calendar", label: "agenda" },
  { path: "/calendar/flowboard", icon: "kanban", label: "flowAttendances" },
  { path: "/hospitalization", icon: "hospital", label: "hospitalization" },
  { path: "/daycare-hotel", icon: "daycare-hotel", label: "daycareHotel" },
  { path: "/catalog", icon: "box", label: "catalog" },
  { path: "/reports", icon: "report", label: "reports" },
  { path: "/sales", icon: "cash-register", label: "sales" },
  { path: "/financial", icon: "wallet", label: "financial" },
];

export function getMainNavTargetPath(path: string, canAccessGrooming: boolean): string {
  if (path === "/calendar") {
    return "/calendar";
  }

  if (path === "/calendar/flowboard") {
    return getLastFlowWorkspacePath(canAccessGrooming);
  }

  return path;
}

export function isMainNavActive(path: string, pathname: string): boolean {
  const normalizedPath = path.endsWith("/") ? path.slice(0, -1) : path;

  if (path === "/calendar") {
    return pathname === "/calendar";
  }

  if (path === "/calendar/flowboard") {
    return pathname === "/calendar/flowboard" || pathname === "/grooming";
  }

  if (path === "/catalog") {
    return (
      pathname === "/catalog" ||
      pathname.startsWith("/catalog/") ||
      pathname === "/products-services" ||
      pathname.startsWith("/products-services/")
    );
  }

  return pathname === normalizedPath || pathname.startsWith(`${normalizedPath}/`);
}

export function getNavItemLabel(item: MainNavItem, t: (key: string) => string, daycareHotelLabelKey: string): string {
  return t(item.path === "/daycare-hotel" ? daycareHotelLabelKey : item.label);
}
